/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../components";
import { images } from "../../config/images";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { ChangeModal } from "./ChangeModal";
import { GetProfile } from "../../redux/Slice/Profile/ProfileDetailSlice";
import { LableFromEnums } from "../../utilities";
import { toast } from "react-toastify";


const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const { UserProfileDetails, UserRole , profileErrorMessage } = useAppSelector((state) => state.profileDetail);
  const [changePassword, setChangePassword] = useState(false);
  const [modalName, setModalName] = useState("")

  const handleEdit = () => {
    navigate("/update-profile");
  };

  if (profileErrorMessage) {
    toast.error(profileErrorMessage.message)
  }

  useEffect(() => {
    dispatch(GetProfile());
  }, []);

  return (
    <>
      {UserProfileDetails && (
        <>
          <Container fluid className="g-0">
            <Card>
              <Card.Body>
                <div className="page-title align-items-center d-flex justify-content-between">
                  <Card.Title className="mb-0">Profile</Card.Title>
                  {["SUPER_ADMIN", "END_USER"].includes(UserRole?.role?.name) &&
                    <ButtonGroup>
                      <Button
                        onClick={handleEdit}
                        type="button"
                        bname="Edit Profile"
                        name="edit-profile"
                        id="edit-profile"
                        className="btn btn-primary me-2 rounded-1"
                      ></Button>
                      {["END_USER"].includes(UserRole?.role?.name) &&
                        <Button
                          onClick={() => {
                            setModalName("Delete")
                            setChangePassword(true);
                          }}
                          type="button"
                          bname="Delete Profile"
                          name="delete-profile"
                          id="delete-profile"
                          className="btn btn-primary me-2 rounded-1"
                        ></Button>
                      }
                    </ButtonGroup>}
                </div>
                <Row>
                  <Col lg={"3"} className="g-0">
                    <div className="align-items-center d-flex flex-column left-user-pic pt-3">
                      <div className="user-img">
                        <img
                          src={
                            UserProfileDetails?.userImage
                              ? UserProfileDetails?.userImage
                              : images.imgupload.default
                          }
                          alt=""
                          width="78"
                          height="78"
                          className="rounded-1 bg-dark"
                        />

                      </div>
                      <span className="badges badges-success bg-opacity-50 bg-primary fw-semibold mb-2 mt-3 rounded-pill text-nowrap">
                        {UserRole?.role?.displayName}
                      </span>
                      <div className="user-name">
                        <h5 className="fw-semibold">
                          {UserProfileDetails?.firstName} {UserProfileDetails?.lastName}{" "}
                          <small className="text-info">{LableFromEnums(UserProfileDetails?.gender, Enums)}</small>
                        </h5>
                      </div>
                      {["SUPER_ADMIN", "END_USER"].includes(UserRole?.role?.name) && <>
                        <Button
                          type="button"
                          bname="Change Password"
                          name="changepassword"
                          id="changepassword"
                          onClick={() => {
                            setModalName("Password")
                            setChangePassword(true);
                          }}
                          className="btn btn-primary px-4 rounded-1 mt-3"
                        ></Button>
                      </>}
                      {["END_USER"].includes(UserRole?.role?.name) && <>

                        <div className="d-flex flex-wrap justify-content-between px-3 py-3">
                          <span className="user-info-title text-info d-block mb-2">
                            Total Games Played
                          </span>
                          <span className="user-info">{UserProfileDetails?.totalPlayedSports}</span>
                          <span className="user-info-title text-info d-block mb-2">
                            Available Reward Points
                          </span>
                          <span className="user-info">{UserProfileDetails?.availableRewardPoints}</span>
                          <span className="user-info-title text-info d-block mb-2">
                            Used Reward Points
                          </span>
                          <span className="user-info">{UserProfileDetails?.usedRewardPoints}</span>
                        </div>
                      </>
                      }
                    </div>
                  </Col>
                  <Col lg={"9"}>
                    <div className="right-user-information ps-5 pb-5">
                      <Row className="text-start row-mb">
                        <Col lg={6}>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Mobile Number
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.countryCode} {UserProfileDetails?.phone}{" "}
                            {UserProfileDetails?.isPhoneVerified &&
                              <span className="badges ms-3 rounded-pill text-success badges-success">
                                Verified
                              </span>}
                            {["SUPER_ADMIN", "END_USER"].includes(UserRole?.role?.name) && <>
                              <img alt="" src={images.updateicon.default} style={{ width: '12%' }} className="btn border-0" onClick={() => {
                                setChangePassword(true);
                                setModalName("Phone Number")
                              }} />
                            </>}
                          </span>

                        </Col>
                        <Col lg={6}>
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Email Address
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.email ? UserProfileDetails?.email : "-"}
                            {UserProfileDetails?.isEmailVerified &&
                              <span className="badges ms-3 rounded-pill text-success badges-success">
                                Verified
                              </span>}
                            {["SUPER_ADMIN", "END_USER"].includes(UserRole?.role?.name) && <>
                              <img alt="" src={images.updateicon.default} style={{ width: '12%' }} className="btn border-0" onClick={() => {
                                setChangePassword(true);
                                setModalName("Email")
                              }} />
                            </>}
                          </span>
                        </Col>
                      </Row>
                      {UserRole?.role?.name !== "END_USER" &&
                        <Row className="text-start row-mb">
                          <Col lg={6} >
                            <span className="user-info-title text-info text-uppercase d-block mb-2">
                              Aadhar number
                            </span>
                            <span className="user-info">{UserProfileDetails?.aadharNumber ? UserProfileDetails.aadharNumber : "-"}</span>
                          </Col>
                          <Col lg={6}>
                            <span className="user-info-title text-info text-uppercase d-block mb-2">
                              Date of birth
                            </span>
                            <span className="user-info">{UserProfileDetails?.birthDate ? UserProfileDetails?.birthDate : "-"}</span>
                          </Col>
                        </Row>
                      }
                      <Row className="text-start">
                        <Col lg={6} className="row-mb">
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Address
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.addressLine1} {UserProfileDetails?.addressLine2 ? ", " + UserProfileDetails?.addressLine2 : ""}
                          </span>
                        </Col>
                        {UserRole?.role?.name !== "END_USER" &&
                          <Col lg={6} className="row-mb">
                            <span className="user-info-title text-info text-uppercase d-block mb-2">
                              Landmark
                            </span>
                            <span className="user-info">
                              {UserProfileDetails?.landmark ? UserProfileDetails?.landmark : "-"}
                            </span>
                          </Col>
                        }

                        <Col lg={6} className="row-mb">
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Pincode
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.pincode}
                          </span>
                        </Col>
                        <Col lg={6} className="row-mb">
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            City
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.city}
                          </span>
                        </Col>
                        <Col lg={6} className="row-mb">
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            State
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.state}
                          </span>
                        </Col>
                        <Col lg={6} className="row-mb">
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Country
                          </span>
                          <span className="user-info">
                            {UserProfileDetails?.country}
                          </span>
                        </Col>
                        <Col lg={6} className="row-mb">
                          <span className="user-info-title text-info text-uppercase d-block mb-2">
                            Created at
                          </span>
                          <span className="user-info">{UserProfileDetails?.createdAt}</span>
                        </Col>
                      </Row>

                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
          <ChangeModal
            changePassword={changePassword}
            setChangePassword={setChangePassword}
            modalName={modalName}
            phoneNo={UserProfileDetails?.phone}
          />
        </>
      )}
    </>
  );
};

export { Profile };
